import React from "react";
import { LegalLayout, LegalSection } from "@/components/site/LegalLayout";
import { SITE, LEGAL } from "@/lib/site-data";

export default function LegalNotice() {
    return (
        <LegalLayout title="Mentions légales" updated={LEGAL.updated} testId="legal-notice-page">
            <LegalSection title="Éditeur du site">
                <p>
                    {LEGAL.company}<br />
                    {SITE.address.line1}, {SITE.address.zip} {SITE.address.city}, Suisse<br />
                    Forme juridique : {LEGAL.legalForm}<br />
                    IDE : {LEGAL.uid}<br />
                    Registre du commerce (VD) : {LEGAL.commerceRegister}<br />
                    N° TVA : {LEGAL.vat}<br />
                    Téléphone : <a className="ll-link-underline" href={`tel:${SITE.phone}`}>{SITE.phoneDisplay}</a><br />
                    E-mail : <a className="ll-link-underline" href={`mailto:${SITE.email}`}>{SITE.email}</a>
                </p>
                <p>Responsable du contenu : {LEGAL.responsible}.</p>
            </LegalSection>

            <LegalSection title="Conception et réalisation">
                <p>
                    Site conçu et développé par{" "}
                    <a className="ll-link-underline text-brand-primary" href={LEGAL.studioUrl} target="_blank" rel="noopener noreferrer">{LEGAL.studio}</a>.
                </p>
            </LegalSection>

            <LegalSection title="Hébergement">
                <p>Le site est hébergé par {LEGAL.host}. Les e-mails sont envoyés via Infomaniak Network SA, Genève, Suisse.</p>
            </LegalSection>

            <LegalSection title="Propriété intellectuelle">
                <p>
                    L'ensemble des contenus de ce site (textes, photographies, logo, mise en page) est la propriété de la
                    Pharmacie La Lutrive ou de ses partenaires. Toute reproduction, même partielle, est interdite sans
                    autorisation écrite préalable. Les logos des marques présentées appartiennent à leurs propriétaires respectifs.
                </p>
            </LegalSection>

            <LegalSection title="Informations de santé">
                <p>
                    Les informations publiées sur ce site sont données à titre général et ne remplacent pas un conseil
                    personnalisé de votre pharmacien ou de votre médecin. En cas d'urgence, appelez le 144.
                </p>
            </LegalSection>

            <LegalSection title="Responsabilité">
                <p>
                    Nous veillons à l'exactitude des informations publiées, sans pouvoir en garantir l'exhaustivité ni
                    l'actualité permanente (horaires, prestations). Dans les limites autorisées par le droit suisse, notre
                    responsabilité ne saurait être engagée pour un dommage résultant de l'utilisation de ces
                    informations ou d'une indisponibilité temporaire du site ; demeure réservée la responsabilité pour
                    faute intentionnelle ou grave négligence. Nous n'avons pas d'influence sur le contenu des sites
                    externes vers lesquels renvoient des liens et n'en assumons pas la responsabilité.
                </p>
            </LegalSection>

            <LegalSection title="Droit applicable">
                <p>Le présent site est soumis au droit suisse. For juridique : Lausanne (canton de Vaud).</p>
            </LegalSection>
        </LegalLayout>
    );
}
